import { makeStyles } from '@mui/styles';
import { useState } from 'react';

import LeftNav from './LeftNav';
import ChatBot from '@/components/ChatBot';
import { checkFeatureFlag } from '@/common/utils/featureFlags';
import RightContentDrawer from './RightContentDrawer';

const useStyles: any = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    minWidth: '100%',
    overflowY: 'hidden'
  },
  mainExpandedNav: {
    width: 'calc(100vw - 240px)',
    minHeight: '100%',
    '& > div': {
      height: '100%',
      '& > .MuiContainer-root': {
        padding: 0,
        maxWidth: 'initial'
      }
    }
  },
  mainCollapsedNav: {
    width: 'calc(100vw - 64px)',
    minHeight: '100%',
    '& > div': {
      height: '100%',
      '& > .MuiContainer-root': {
        padding: 0,
        maxWidth: 'initial'
      }
    }
  }
}));

type Props = {
  children: React.ReactNode;
};

function DashboardLayout({ children }: Props) {
  const classes = useStyles();

  const [leftNavIsOpen, setLeftNavIsOpen] = useState(false);

  const setIsOpenAndResize = open => {
    setLeftNavIsOpen(open);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 120);
  };

  return (
    <div className={classes.root}>
      <LeftNav isOpen={leftNavIsOpen} setIsOpen={setIsOpenAndResize} />
      <div
        className={
          leftNavIsOpen ? classes.mainExpandedNav : classes.mainCollapsedNav
        }
      >
        {children}
      </div>
      <RightContentDrawer />
      {checkFeatureFlag('CHAT_BOT') && <ChatBot />}
    </div>
  );
}

export default DashboardLayout;
